/* ============================================================
   Limiar Studio — Página Personalizados
   Formulário em etapas → envio pelo WhatsApp ou e-mail → confirmação (no hero e na seção de baixo).
   Sem dependências. Funciona mesmo se o 3D falhar.
   ============================================================ */
(function () {
  'use strict';

  var doc = document;
  var win = window;
  var reduceMotion = win.matchMedia && win.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STEP_STORAGE_KEY = 'limiar:personalizados';
  var CONTACT_PENDING_KEY = 'limiar:personalizados:contato';
  var CONTACT_TIMEOUT = 30000;
  var UTM_STORAGE_KEY = 'limiar:utm';
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
  var TOTAL_STEPS = 2;

  /* ---- Analytics: apenas nomes de evento e dados não pessoais ---- */
  function track(name, data) {
    var payload = data || {};
    try {
      win.dataLayer = win.dataLayer || [];
      var entry = { event: name };
      for (var k in payload) if (Object.prototype.hasOwnProperty.call(payload, k)) entry[k] = payload[k];
      win.dataLayer.push(entry);
    } catch (e) { /* noop */ }
    try {
      if (win.Shopify && win.Shopify.analytics && typeof win.Shopify.analytics.publish === 'function') {
        win.Shopify.analytics.publish(name, payload);
      }
    } catch (e) { /* noop */ }
    try { doc.dispatchEvent(new CustomEvent('limiar:analytics', { detail: { name: name, data: payload } })); } catch (e) { /* noop */ }
  }

  /* ---- Scroll suave até âncoras internas ---- */
  function scrollToEl(el, focusEl) {
    if (!el) return;
    el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    if (focusEl) {
      try { focusEl.focus({ preventScroll: true }); } catch (e) { focusEl.focus(); }
    }
  }

  function bindScrollLinks() {
    doc.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('[data-pz-scroll]');
      if (!link) return;
      var hash = link.getAttribute('href') || '';
      if (hash.charAt(0) !== '#') return;
      var target = doc.getElementById(hash.slice(1));
      if (!target) return;
      e.preventDefault();
      var where = link.getAttribute('data-pz-cta') || '';
      if (where === 'hero') track('personalizados_hero_cta', { cta: 'primary' });
      else if (where === 'hero_secondary') track('personalizados_hero_cta', { cta: 'secondary' });
      else if (where) track('personalizados_cta', { location: where });
      var heading = target.querySelector('h2[tabindex]');
      scrollToEl(target, heading);
      if (history.replaceState) history.replaceState(null, '', hash);
    });
  }

  /* ---- Reveal ---- */
  function bindReveal() {
    if (reduceMotion || !('IntersectionObserver' in win)) return;
    var nodes = doc.querySelectorAll('[data-pz-reveal]');
    if (!nodes.length) return;
    doc.documentElement.classList.add('pz-anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    for (var i = 0; i < nodes.length; i++) io.observe(nodes[i]);
  }

  /* ---- Progresso por scroll (linha do processo e transição) ---- */
  function bindProgress() {
    if (reduceMotion) return;
    var sections = [].slice.call(doc.querySelectorAll('[data-pz-progress]'));
    if (!sections.length) return;
    var active = [];
    var ticking = false;

    function update() {
      ticking = false;
      var vh = win.innerHeight;
      active.forEach(function (el) {
        var r = el.getBoundingClientRect();
        /* 0 quando o topo entra a 85% da tela; 1 quando a seção chega ao centro */
        var start = vh * 0.85, done = vh * 0.5 - r.height * 0.5;
        var p = (start - r.top) / Math.max(1, start - done);
        p = p < 0 ? 0 : p > 1 ? 1 : p;
        el.style.setProperty('--p', p.toFixed(3));
      });
    }
    function onScroll() { if (!ticking) { ticking = true; win.requestAnimationFrame(update); } }

    sections.forEach(function (el) { el.style.setProperty('--p', '0'); });
    if (!('IntersectionObserver' in win)) {
      active = sections;
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var i = active.indexOf(en.target);
          if (en.isIntersecting && i < 0) active.push(en.target);
          if (!en.isIntersecting && i >= 0) {
            active.splice(i, 1);
            var r = en.target.getBoundingClientRect();
            en.target.style.setProperty('--p', r.top < 0 ? '1' : '0');
          }
        });
        onScroll();
      }, { rootMargin: '10% 0px' });
      sections.forEach(function (el) { io.observe(el); });
    }
    win.addEventListener('scroll', onScroll, { passive: true });
    win.addEventListener('resize', onScroll, { passive: true });
  }

  /* ============================================================
     WhatsApp — clique rastreado com a origem (hero, final, flutuante, formulario)
     ============================================================ */
  function bindWhatsApp() {
    doc.addEventListener('click', function (e) {
      /* clique que abriu o modal de WhatsApp (assets/whatsapp-lead.js) ainda não abriu a conversa */
      if (e.defaultPrevented) return;
      var link = e.target.closest && e.target.closest('[data-pz-whatsapp-origin]');
      if (link) track('personalizados_whatsapp_click', { origin: link.getAttribute('data-pz-whatsapp-origin') });
    });
  }

  /* ============================================================
     Formulários — utilitários compartilhados
     ============================================================ */
  /* Máscara e validação de celular: compartilhadas com o modal de WhatsApp (assets/whatsapp-lead.js) */
  function maskPhone(value) { return win.LimiarPhone.mask(value); }
  function phoneIsValid(value) { return win.LimiarPhone.isValid(value); }

  function emailIsValid(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  /* Esconde o CTA do topo enquanto algum formulário está na tela (qualquer parte visível conta). */
  var formsInView = [];
  function setFormInView(el, inView) {
    var i = formsInView.indexOf(el);
    if (inView && i < 0) formsInView.push(el);
    if (!inView && i >= 0) formsInView.splice(i, 1);
    doc.body.classList.toggle('pz-form-active', formsInView.length > 0);
  }

  function watchForm(el, isActive) {
    if (!('IntersectionObserver' in win)) return;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { setFormInView(el, en.isIntersecting && (!isActive || isActive())); });
    }, { threshold: 0 }).observe(el);
  }

  /* ============================================================
     Formulário em 2 etapas (hero e seção de baixo): ideia → contato → envio (WhatsApp ou e-mail) → confirmação
     ============================================================ */
  var STEP_MESSAGES = {
    idea: 'Conta um pouquinho sobre sua ideia para continuarmos.',
    name: 'Só falta seu nome.',
    phone: 'Precisamos do seu WhatsApp para continuar a conversa.',
    phoneInvalid: 'Confere o número? Coloca o DDD junto, por exemplo (11) 99999-9999.',
    email: 'Esse e-mail parece incompleto. Confere pra gente?',
    consent: 'Para continuar, precisamos da sua autorização para entrar em contato.',
    preference: 'Escolha como prefere receber o orçamento e continuar a conversa.',
    emailMissing: 'Para receber o orçamento por e-mail, precisamos do seu e-mail.'
  };

  var PREFERENCE_LABELS = { whatsapp: 'WhatsApp', email: 'E-mail' };
  var REQUEST_TIMEOUT = 15000;

  /* maskPhone, phoneIsValid e emailIsValid são compartilhados com o formulário de orçamento */

  /* UTMs da chegada à página: guardadas na sessão para sobreviver à navegação interna */
  function utmParams() {
    var out = {};
    try {
      var search = new URLSearchParams(win.location.search);
      UTM_KEYS.forEach(function (k) { if (search.get(k)) out[k] = search.get(k).slice(0, 120); });
      if (Object.keys(out).length) win.sessionStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(out));
      else out = JSON.parse(win.sessionStorage.getItem(UTM_STORAGE_KEY) || '{}') || {};
    } catch (e) { /* sem UTMs */ }
    return out;
  }

  function newId() {
    if (win.crypto && typeof win.crypto.randomUUID === 'function') return win.crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  /* Envio em segundo plano que sobrevive à troca de aba/app (WhatsApp abrindo por cima).
     sendBeacon manda form-urlencoded sem preflight; a resposta não importa aqui. */
  function beacon(url, body) {
    try {
      if (win.navigator.sendBeacon && win.navigator.sendBeacon(url, body)) return;
    } catch (e) { /* tenta o fetch */ }
    if (win.fetch) win.fetch(url, { method: 'POST', body: body, keepalive: true, mode: 'no-cors' }).catch(function () { /* noop */ });
  }

  function initStepForm(form) {
    var section = form.closest('[data-pz-form-section]') || form;
    var steps = [].slice.call(form.querySelectorAll('[data-pz-step]'));
    var stepLabel = form.querySelector('[data-pz-step-label]');
    var progressFill = form.querySelector('[data-pz-progress-fill]');
    var progressUi = form.querySelector('[data-pz-progress-ui]');
    var submitBtn = form.querySelector('[data-pz-submit]');
    var submitLabel = form.querySelector('[data-pz-submit-label]');
    var submitIcon = form.querySelector('[data-pz-submit-icon]');
    var sendStatus = form.querySelector('[data-pz-send-status]');
    var waFallback = form.querySelector('[data-pz-whatsapp]');
    var number = (form.getAttribute('data-whatsapp') || '').replace(/\D/g, '');
    var contactForm = doc.getElementById(form.getAttribute('data-contact-form') || '');
    var contactTimer = null;
    /* Inbox (guarda o pedido e avisa o atendimento por e-mail); o Apps Script só entra se não houver Inbox */
    var leadsEndpoint = form.getAttribute('data-leads-endpoint') || '';
    var endpoint = leadsEndpoint || form.getAttribute('data-endpoint') || '';
    var loadedAt = Date.now();
    var sending = false;
    /* id do pedido: o mesmo em cliques repetidos (Inbox e e-mail não duplicam); muda se os dados mudarem */
    var submissionId = null;
    var utm = utmParams();
    /* origem da instância (formulario_hero | formulario): rascunho e rastreamento separados */
    var origin = form.getAttribute('data-pz-origin') || 'formulario';
    var storageKey = STEP_STORAGE_KEY + ':' + origin;
    var el = {
      idea: form.elements.idea,
      name: form.elements.name,
      phone: form.elements.phone,
      email: form.elements.email,
      consent: form.elements.consent
    };

    var current = 1;
    var started = false;
    var completed = {};

    function radioValue(name) {
      var r = form.querySelector('input[name="' + name + '"]:checked');
      return r ? r.value : '';
    }

    function setRadio(name, value) {
      var r = value && form.querySelector('input[name="' + name + '"][value="' + value + '"]');
      if (r) r.checked = true;
    }

    function data() {
      return {
        idea: (el.idea.value || '').trim(),
        name: (el.name.value || '').trim(),
        phone: (el.phone.value || '').trim(),
        email: (el.email.value || '').trim(),
        preference: radioValue('preference'),
        consent: !!el.consent.checked
      };
    }

    /* ---- Persistência temporária (sessionStorage) ---- */
    function save() {
      try {
        var d = data();
        d.preferenceRaw = radioValue('preference');
        d.step = Math.min(current, TOTAL_STEPS);
        win.sessionStorage.setItem(storageKey, JSON.stringify(d));
      } catch (e) { /* armazenamento indisponível: segue sem salvar */ }
    }

    function clearSaved() {
      try { win.sessionStorage.removeItem(storageKey); } catch (e) { /* noop */ }
    }

    function restore() {
      var saved;
      try { saved = JSON.parse(win.sessionStorage.getItem(storageKey) || 'null'); } catch (e) { saved = null; }
      if (!saved) return 1;
      el.idea.value = saved.idea || '';
      setRadio('preference', saved.preferenceRaw);
      el.name.value = saved.name || '';
      el.phone.value = saved.phone || '';
      el.email.value = saved.email || '';
      el.consent.checked = !!saved.consent;
      started = !!saved.idea;
      var step = parseInt(saved.step, 10) || 1;
      return step >= 1 && step <= TOTAL_STEPS ? step : 1;
    }

    /* ---- Erros ---- */
    function setError(key, message, input) {
      var box = form.querySelector('[data-pz-error="' + key + '"]');
      if (box) box.textContent = message || '';
      var targets = el[key] ? [el[key]] : input ? [].slice.call(form.querySelectorAll('input[name="' + input.name + '"]')) : [].slice.call(form.querySelectorAll('input[name="' + key + '"]'));
      targets.forEach(function (target) {
        if (message) target.setAttribute('aria-invalid', 'true');
        else target.removeAttribute('aria-invalid');
      });
    }

    function validate(step) {
      var d = data();
      var first = null;
      function fail(key, msg, input) { setError(key, msg, input); if (!first) first = input || el[key]; }

      if (step === 1) {
        if (d.idea.length < 3) fail('idea', STEP_MESSAGES.idea);
      }
      if (step === 2) {
        if (!d.name) fail('name', STEP_MESSAGES.name);
        if (!d.preference) fail('preference', STEP_MESSAGES.preference, form.querySelector('input[name="preference"]'));
        /* o contato do canal escolhido é obrigatório; o outro, opcional */
        if (!d.phone && d.preference !== 'email') fail('phone', STEP_MESSAGES.phone);
        else if (d.phone && !phoneIsValid(d.phone)) fail('phone', STEP_MESSAGES.phoneInvalid);
        if (!d.email && d.preference === 'email') fail('email', STEP_MESSAGES.emailMissing);
        else if (d.email && !emailIsValid(d.email)) fail('email', STEP_MESSAGES.email);
        if (!d.consent) fail('consent', STEP_MESSAGES.consent);
      }
      if (first) { first.focus(); return false; }
      return true;
    }

    /* ---- Navegação entre etapas ---- */
    function updateProgress(step) {
      var shown = Math.min(step, TOTAL_STEPS);
      if (stepLabel) stepLabel.textContent = step > TOTAL_STEPS ? 'Pedido enviado' : 'Etapa ' + shown + ' de ' + TOTAL_STEPS;
      if (progressFill) progressFill.style.setProperty('--progress', String(step > TOTAL_STEPS ? 1 : shown / TOTAL_STEPS));
      if (progressUi) progressUi.setAttribute('data-step', String(step));
    }

    function show(step, opts) {
      opts = opts || {};
      current = step;
      steps.forEach(function (s) { s.hidden = parseInt(s.getAttribute('data-pz-step'), 10) !== step; });
      updateProgress(step);
      if (step <= TOTAL_STEPS) save();
      if (opts.scroll !== false) {
        var stepEl = form.querySelector('[data-pz-step="' + step + '"]');
        var title = stepEl && stepEl.querySelector('.pz-step__title');
        var r = form.getBoundingClientRect();
        /* só rola se o início do formulário não estiver visível */
        if (r.top < 0 || r.top > win.innerHeight * 0.6) scrollToEl(progressUi || form, title);
        else if (title) { try { title.focus({ preventScroll: true }); } catch (e) { title.focus(); } }
      }
    }

    function complete(step) {
      var d = data();
      if (completed[step]) return;
      completed[step] = true;
      if (step === 1) track('personalizados_step_1_complete');
      if (step === 2) track('personalizados_contact_complete');
    }

    function next() {
      if (!validate(current)) return;
      complete(current);
      if (current === TOTAL_STEPS) { finish(); return; }
      show(current + 1);
    }

    function back() {
      show(Math.max(current - 1, 1));
    }

    /* ---- Textos do pedido ---- */
    function buildMessage(d, forWhatsApp) {
      var lines = forWhatsApp ? [
        'Oi, Limiar! Acabei de enviar minha ideia pelo site e queria continuar a conversa por aqui.',
        ''
      ] : [
        'Olá, Limiar!',
        'Tenho uma ideia que gostaria de transformar em um projeto.',
        ''
      ];
      lines = lines.concat([
        'Minha ideia:',
        d.idea,
        '',
        'Meu nome é ' + d.name + '.'
      ]);
      var contact = [];
      if (d.phone) contact.push('WhatsApp: ' + d.phone);
      if (d.email) contact.push('E-mail: ' + d.email);
      if (contact.length) lines.push(contact.join(' · '));
      if (d.preference) lines.push('Prefiro receber o orçamento e continuar a conversa por ' + (d.preference === 'email' ? 'e-mail' : 'WhatsApp') + '.');
      if (!forWhatsApp) lines.push('Vim pelo Personalizados do site e gostaria de entender como podemos desenvolver essa ideia.');
      return lines.join('\n');
    }

    function whatsappUrl(d) {
      return 'https://wa.me/' + number + '?text=' + encodeURIComponent(buildMessage(d, true));
    }

    /* ---- Botão de envio da etapa 2: rótulo e dica conforme o canal escolhido ---- */
    function updateOptional(pref) {
      [].forEach.call(form.querySelectorAll('[data-pz-optional]'), function (tag) {
        var field = tag.getAttribute('data-pz-optional');
        /* opcional é o contato do canal não escolhido; sem escolha, o WhatsApp segue obrigatório */
        tag.hidden = field === 'email' ? pref === 'email' : pref !== 'email';
      });
    }

    function submitText(pref) {
      return pref === 'whatsapp' ? 'Enviar pelo WhatsApp' : pref === 'email' ? 'Enviar por e-mail' : 'Enviar minha ideia';
    }

    function updateSubmit(pref) {
      if (!sending && submitLabel) submitLabel.textContent = submitText(pref);
      if (submitIcon) submitIcon.hidden = pref !== 'whatsapp';
      [].forEach.call(form.querySelectorAll('[data-pz-submit-hint]'), function (hint) {
        hint.hidden = hint.getAttribute('data-pz-submit-hint') !== pref;
      });
    }

    function setBusy(state) {
      sending = state;
      if (!submitBtn) return;
      submitBtn.classList.toggle('is-loading', state);
      submitBtn.setAttribute('aria-busy', state ? 'true' : 'false');
      if (submitLabel) submitLabel.textContent = state ? 'Enviando…' : submitText(radioValue('preference'));
    }

    function setSendStatus(text, d) {
      if (!sendStatus) return;
      sendStatus.textContent = text;
      if (d) {
        var a = doc.createElement('a');
        a.href = whatsappUrl(d);
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.setAttribute('data-pz-whatsapp-origin', origin);
        a.textContent = 'fale com a gente pelo WhatsApp';
        sendStatus.appendChild(doc.createTextNode(' '));
        sendStatus.appendChild(a);
      }
    }

    /* ---- Dados do pedido: mesmo formato para a Inbox e para o Apps Script ---- */
    function payload(d) {
      if (!submissionId) submissionId = newId();
      var body = new URLSearchParams();
      body.append('id', submissionId);
      body.append('name', d.name);
      body.append('email', d.email);
      body.append('phone', d.phone);
      body.append('preference', d.preference);
      body.append('idea', d.idea);
      body.append('origin', origin);
      body.append('website', '');
      body.append('elapsed', String(Date.now() - loadedAt));
      body.append('page', win.location.origin + win.location.pathname);
      for (var k in utm) if (Object.prototype.hasOwnProperty.call(utm, k)) body.append(k, utm[k]);
      return body;
    }

    /* Envio com resposta (caminho do e-mail): só confirma quando o servidor disser ok */
    function post(d) {
      var controller = 'AbortController' in win ? new AbortController() : null;
      var timer = controller && win.setTimeout(function () { controller.abort(); }, REQUEST_TIMEOUT);
      return win.fetch(endpoint, { method: 'POST', body: payload(d), signal: controller ? controller.signal : undefined })
        .then(function (res) { return res.json(); })
        .then(function (json) {
          if (timer) win.clearTimeout(timer);
          if (!json || json.ok !== true) throw new Error((json && json.error && (json.error.code || json.error)) || 'server');
        }, function (err) {
          if (timer) win.clearTimeout(timer);
          throw err;
        });
    }

    /* ---- Envio (botão da etapa 2) ---- */
    function finish() {
      if (sending) return;
      var d = data();
      setSendStatus('');
      if (d.preference === 'whatsapp') {
        var url = whatsappUrl(d);
        /* registra e avisa o atendimento em segundo plano: sobrevive à troca para o app do WhatsApp */
        if (endpoint) beacon(endpoint, payload(d));
        track('personalizados_whatsapp_click', { origin: origin });
        /* abre no mesmo gesto do clique (sem espera), senão o navegador bloqueia a nova aba */
        var opened = null;
        try { opened = win.open(url, '_blank'); } catch (e) { opened = null; }
        if (opened) { try { opened.opener = null; } catch (e) { /* noop */ } }
        showDone(d, url);
        return;
      }
      setBusy(true);
      if (!endpoint || !win.fetch) { submitContact(d); return; }
      post(d).then(function () {
        track('personalizados_email_submit', { origin: origin, method: leadsEndpoint ? 'inbox' : 'apps_script' });
        setBusy(false);
        showDone(d);
      }, function (err) {
        track('personalizados_email_error', { origin: origin, method: leadsEndpoint ? 'inbox' : 'apps_script', reason: (err && err.name === 'AbortError') ? 'timeout' : (err && err.message) || 'network' });
        submitContact(d); /* alternativa: formulário de contato da Shopify */
      });
    }

    /* Etapa final: confirmação com o resumo do que foi enviado */
    function showDone(d, url) {
      var out = {
        idea: d.idea,
        name: d.name,
        preference: PREFERENCE_LABELS[d.preference] || '—'
      };
      [].forEach.call(form.querySelectorAll('[data-pz-out]'), function (node) {
        node.textContent = out[node.getAttribute('data-pz-out')] || '—';
      });
      var channel = d.preference === 'email' ? 'email' : 'whatsapp';
      [].forEach.call(form.querySelectorAll('[data-pz-done]'), function (node) {
        node.hidden = node.getAttribute('data-pz-done') !== channel;
      });
      if (waFallback) waFallback.href = url || whatsappUrl(d);
      clearSaved();
      show(TOTAL_STEPS + 1);
    }

    /* Formulário de contato nativo: a página recarrega e volta com ?contact_posted=true */
    function submitContact(d) {
      if (!contactForm) {
        setBusy(false);
        setSendStatus('Não conseguimos enviar agora. Tente de novo ou', d);
        return;
      }
      var values = {
        name: d.name,
        email: d.email,
        phone: d.phone,
        preference: PREFERENCE_LABELS[d.preference] || '',
        origin: origin === 'formulario_hero' ? 'Formulário do topo' : 'Formulário da página',
        body: buildMessage(d)
      };
      [].forEach.call(contactForm.querySelectorAll('[data-pz-contact-field]'), function (input) {
        input.value = values[input.getAttribute('data-pz-contact-field')] || '';
      });
      save(); /* mantém os dados caso a Shopify devolva erro */
      try { win.sessionStorage.setItem(CONTACT_PENDING_KEY, contactForm.id); } catch (e) { /* noop */ }
      track('personalizados_email_submit', { origin: origin, method: 'shopify_contact' });

      /* Se nada acontecer (captcha não carregou, rede), libera o botão em vez de ficar em "Enviando…" */
      win.clearTimeout(contactTimer);
      contactTimer = win.setTimeout(function () {
        if (!sending) return;
        try { win.sessionStorage.removeItem(CONTACT_PENDING_KEY); } catch (e) { /* noop */ }
        track('personalizados_email_error', { origin: origin, method: 'shopify_contact', reason: 'timeout' });
        setBusy(false);
        setSendStatus('Não conseguimos confirmar o envio. Tente de novo ou', d);
      }, CONTACT_TIMEOUT);

      /* O captcha da Shopify precisa estar "armado" no formulário antes do envio;
         Shopify.captcha.protect arma e chama o callback quando estiver pronto. */
      var captcha = win.Shopify && win.Shopify.captcha;
      var bound = contactForm.dataset.hcaptchaBound || contactForm.dataset.recaptchaBound;
      if (!bound && captcha && typeof captcha.protect === 'function') {
        try { captcha.protect(contactForm, fireContactSubmit); return; } catch (e) { /* segue sem proteger */ }
      }
      fireContactSubmit();
    }

    /* Envio com evento "submit" (não form.submit()): é nesse evento que o hCaptcha gera o token */
    function fireContactSubmit() {
      if (typeof contactForm.requestSubmit === 'function') {
        contactForm.requestSubmit();
      } else {
        var trigger = contactForm.querySelector('[data-pz-contact-submit]');
        if (trigger) trigger.click();
      }
    }

    /* ---- Eventos ---- */
    form.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-pz-next]')) { e.preventDefault(); next(); return; }
      if (t.closest('[data-pz-back]')) { e.preventDefault(); back(); }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (current <= TOTAL_STEPS) next();
    });

    /* Enter em campos de linha única avança a etapa (textarea mantém a quebra de linha) */
    form.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' || e.isComposing) return;
      var t = e.target;
      if (t.tagName === 'TEXTAREA' || t.tagName === 'BUTTON' || t.tagName === 'A') return;
      if (t.type === 'checkbox') return;
      e.preventDefault();
      if (current <= TOTAL_STEPS) next();
    });

    form.addEventListener('input', function (e) {
      var t = e.target;
      if (t === el.idea && !started && t.value.trim()) {
        started = true;
        track('personalizados_form_start');
      }
      if (t === el.phone) {
        var caretAtEnd = t.selectionStart === t.value.length;
        var masked = maskPhone(t.value);
        if (masked !== t.value) {
          t.value = masked;
          if (caretAtEnd) t.setSelectionRange(masked.length, masked.length);
        }
      }
      if (t.classList.contains('pz-input')) t.classList.toggle('is-filled', !!t.value.trim());
      if (t.getAttribute('aria-invalid') === 'true') setError(t.name, '', t);
      submissionId = null;
      save();
    });

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'consent' && t.checked) setError('consent', '');
      if (t.name === 'preference') {
        setError('preference', '', t);
        updateOptional(t.value);
        updateSubmit(t.value);
        /* o erro do contato que deixou de ser obrigatório não vale mais */
        if (t.value === 'email' && !el.phone.value.trim()) setError('phone', '');
        if (t.value === 'whatsapp' && !el.email.value.trim()) setError('email', '');
      }
      submissionId = null;
      save();
    });

    /* Voltar do envio pelo histórico (bfcache): libera o botão */
    win.addEventListener('pageshow', function (e) { if (e.persisted && sending) setBusy(false); });

    /* Teclado virtual aberto: tira o botão fixo da base para não cobrir o campo */
    if (win.visualViewport) {
      var vv = win.visualViewport;
      var onViewport = function () { form.classList.toggle('is-typing', vv.height < win.innerHeight * 0.75); };
      vv.addEventListener('resize', onViewport);
      onViewport();
    }

    watchForm(section);

    /* Estado inicial */
    var startStep = restore();
    updateOptional(radioValue('preference'));
    updateSubmit(radioValue('preference'));
    [].forEach.call(form.querySelectorAll('.pz-input'), function (i) { i.classList.toggle('is-filled', !!i.value.trim()); });
    show(startStep, { scroll: false });

    /* Volta do formulário de contato da Shopify: mostra o resultado só no formulário que enviou */
    var contactStatus = contactForm && contactForm.querySelector('[data-pz-contact-status]');
    var pending = null;
    try { pending = win.sessionStorage.getItem(CONTACT_PENDING_KEY); } catch (e) { /* noop */ }
    if (contactStatus && pending === contactForm.id) {
      try { win.sessionStorage.removeItem(CONTACT_PENDING_KEY); } catch (e) { /* noop */ }
      if (contactStatus.value === 'sent') {
        track('personalizados_email_sent', { origin: origin, method: 'shopify_contact' });
        showDone(data());
      } else {
        track('personalizados_email_error', { origin: origin, method: 'shopify_contact' });
        show(TOTAL_STEPS);
        setSendStatus('Não conseguimos enviar seu pedido. Confira o e-mail informado e tente de novo, ou', data());
      }
    }
  }

  function initAll(selector, init) {
    var nodes = doc.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      try { init(nodes[i]); } catch (e) { if (win.console) console.error('[personalizados]', e); }
    }
  }

  /* ---- Depoimentos: slider no mobile, grade estática no desktop ---- */
  function initTestimonials(carousel) {
    var list = carousel.querySelector('.pz-testimonials__list');
    var controls = carousel.querySelector('.pz-testimonials__controls');
    var previous = carousel.querySelector('[data-pz-testimonials-prev]');
    var next = carousel.querySelector('[data-pz-testimonials-next]');
    var dots = carousel.querySelector('[data-pz-testimonials-dots]');
    var slides = list ? list.querySelectorAll('.pz-testimonials__item') : [];
    var mobile = win.matchMedia ? win.matchMedia('(max-width: 899px)') : null;
    var slider = null;

    if (!list || !slides.length || !mobile || !win.KeenSlider) return;

    previous.addEventListener('click', function () { if (slider) slider.prev(); });
    next.addEventListener('click', function () { if (slider) slider.next(); });

    function updateControls(instance) {
      var index = instance.track.details.rel;
      var last = slides.length - 1;
      previous.disabled = index === 0;
      next.disabled = index === last;
      var buttons = dots.querySelectorAll('button');
      for (var i = 0; i < buttons.length; i++) {
        var active = i === index;
        buttons[i].classList.toggle('is-active', active);
        buttons[i].setAttribute('aria-current', active ? 'true' : 'false');
      }
    }

    function create() {
      if (slider || !mobile.matches) return;
      list.classList.add('is-slider', 'keen-slider');
      controls.hidden = slides.length < 2;
      dots.innerHTML = '';
      for (var i = 0; i < slides.length; i++) {
        var dot = doc.createElement('button');
        dot.type = 'button';
        dot.className = 'pz-testimonials__dot';
        dot.setAttribute('aria-label', 'Ir para o depoimento ' + (i + 1));
        (function (index) { dot.addEventListener('click', function () { slider.moveToIdx(index); }); }(i));
        dots.appendChild(dot);
      }
      slider = new win.KeenSlider(list, {
        loop: false,
        renderMode: 'performance',
        slides: { perView: 1, spacing: 0 },
        created: updateControls,
        slideChanged: updateControls
      });
    }

    function destroy() {
      if (!slider) return;
      slider.destroy();
      slider = null;
      list.classList.remove('is-slider', 'keen-slider');
      controls.hidden = true;
      dots.innerHTML = '';
    }

    function sync() { if (mobile.matches) create(); else destroy(); }
    if (mobile.addEventListener) mobile.addEventListener('change', sync);
    else mobile.addListener(sync);
    sync();
  }

  function boot() {
    track('personalizados_view');
    bindScrollLinks();
    bindWhatsApp();
    bindReveal();
    bindProgress();
    initAll('[data-pz-testimonials]', initTestimonials);
    initAll('[data-pz-form]', initStepForm);
  }

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
